module.exports = __webpack_public_path__ + "img/public/SiteIcons/noTransaction.svg?13e9de33";